// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"ca85f01a","732":"0c22843f","977":"e504b9d7"}[chunkId] + ".chunk.js";
};